import script from "./RemindersEntity.vue?vue&type=script&setup=true&lang=js"
export * from "./RemindersEntity.vue?vue&type=script&setup=true&lang=js"

import "./RemindersEntity.vue?vue&type=style&index=0&id=1932c2b7&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1932c2b7"]])

export default __exports__